import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11"><circle cx="5.5" cy="5.5" r="3.5" stroke="#313131" stroke-width=".5"/></svg>`;

export { symbol as default };
